/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-19 14:25:15
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-07 12:46:11
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/FeatureProducts/index.tsx
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { Icon } from '@/src/tools/icon';
import { Collapse } from '@/src/components/Antd';
import { getFeatureProduct, onFeatureProductsChange } from '../slice';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import { useParams, useHistory } from 'react-router-dom';

import styles from './style.module.less';

function FeatureProducts({ currentStyle, currentSize }: any) {
  const dispatch = useDispatch();
  const featureProducts = useSelector(getFeatureProduct());

  const renderTitle = () => (
    <span className={styles.text}>Featured Products</span>
  );
  const h = useHistory();
  const { saleChannelUuid, contentUuid }: any = useParams();
  const onEdit = () => {
    h.push(
      `/salesChannel/editor/content/promotion/${saleChannelUuid}/${contentUuid}`,
    );
  };
  const renderContent = () => {
    return (
      <React.Fragment>
        <div className={styles.content} onClick={onEdit}>
          <Icon type='iconarrow' className={styles.icon} />
          <span>Edit in Promotion Page</span>
        </div>
        <Section>
          <ItemWrapper title={'Title Text Colour'}>
            <ColorPicker
              multi
              onChange={(v) => dispatch(onFeatureProductsChange(v))}
              color={featureProducts?.titleTextColor}
            />
          </ItemWrapper>
        </Section>
      </React.Fragment>
    );
  };
  //console.log('featureProducts', featureProducts);
  return (
    <>
      {featureProducts.isValid ? (
        <Collapse
          clickToExpand
          expandOffset={12}
          title={renderTitle()}
          content={renderContent()}
        />
      ) : null}
    </>
  );
}

export default FeatureProducts;
